<div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
  <div class="date-picker-example">
    @if (title) {
      <div style="padding: 0 16px">{{ title }}</div>
    }
    @if (description) {
      <div class="description">{{ description }}</div>
    }

    @if (type === 'calendar') {
      <div class="calendar">
        <img src="assets/images/checkout-extensions/date-picker-calendar.png" width="100%" />
      </div>
    } @else {
      <img src="assets/images/checkout-extensions/date-picker-field.png" width="100%" />
    }
  </div>
</div>
